import get from 'lodash/get'
import { NurtureValue } from './getNurture'

export const getNurtureProgramSettings = (channelData): NurtureValue | false => {
  const features = get(channelData, 'features')

  if (!features || !Array.isArray(features)) {
    return false
  }

  const nurtureFeature = features.find(
    ({ name, value }) => name === 'nurture' && !!value
  )

  if (!nurtureFeature) {
    return false
  }

  try {
    const parsedValue = JSON.parse(nurtureFeature.value)

    return {
      startDate: parsedValue.startDate,
      endDate: parsedValue.endDate
    }
  } catch (e) {
    return false
  }
}
